export default function LyfegenBadge() {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M13.0427 13.2761H4.40918V16.0061H15.7722C15.7773 17.5079 16.9964 18.7238 18.4994 18.7238H27.5902V15.9966H15.7726C15.7675 14.4932 14.5472 13.2761 13.0427 13.2761Z"
				fill="#212121"
			/>
			<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#CDDCDC" />
		</svg>
	);
}
